export const nameMap: Record<string, string> = { // TODO: use $t instead of nameMap (Delete after transition)
    'INCOMES': 'Доходы',
    'EXPENSES': 'Расходы',
    'REGULATED': 'Регламентированный',
    'UNREGULATED': 'Нерегламентированный',
    'IISK': 'ИС КК',
    'MIXED': 'Смешанный',
    'INCOMES_OR_EXPENSES': 'Доходы / Расходы',
    'LOADER': 'Загрузчик',
    'WITHOUT': 'Без ВЗК',
    'WITH': 'с ВЗК',
    'ONLY': 'Только ВЗК',
    'TENGE': 'теңге',
    'THOUSAND': 'Тыс. теңге',
    'COMPLETE': 'ОБРАБОТАНО',
    'IN_PROGRESS': 'В ОБРАБОТКЕ',
    'ERROR': 'ОШИБКА',

    'region': 'Регион',
    'eregion': 'Регион',

    'kat': 'Категория',
    'cls': 'Класс',
    'pcl': 'Подкласс',
    'epcl': 'Подкласс',
    'spf': 'Специфика',
    'espf': 'Специфика',

    'gr': 'Ф. гр.',
    'pgr': 'Ф. подгр.',
    'abp': 'АБП',
    'gu': 'ГУ',
    'prg': 'БП',
    'ppr': 'БПП'
}
